

































export default {
  props: {
    showEndExerciseSessionDialog: {
      type: Boolean,
      default: false,
    },
    showLoading: {
      type: Boolean,
      default: false,
    },
    exerciseSessionIsComplete: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    openDialog() {
      this.$emit('openEndExerciseSessionDialog')
    },
    closeDialog() {
      this.$emit('closeEndExerciseSessionDialog')
    },
    endLiveExerciseSession() {
      this.$emit('endLiveExerciseSession')
    },
  },
}
